import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-app-holder',
    templateUrl: './app-holder.component.html',
    styleUrls: ['./app-holder.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AppHolderComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
